

export const twoWeekMilliSeconds = 1000 * 60 * 60 * 24 * 14;


export const weeks = ['Sun','Mon', 'Tue','Wed','Thu', 'Fri','Sat']

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May','Jun','Jul','Aug','Sep','Oct', 'Nov','Dec'];


export const convertToDates = (slots, offset) => {

  return Object.keys(slots).map(timestamp => {
    let date = new Date((timestamp - offset) * 1000);
    return {
      date: date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
      day: weeks[date.getDay()],
      disabled: slots[timestamp].length === 0,
      timestamp: parseInt(timestamp),
      slots: slots[timestamp]
    }
  })
  
}

export const convertToTime = (seconds) => {

  let hours = Math.floor(Math.abs(seconds) / 3600);
  let time = 'am';
  if (parseInt(hours) > 11) {
    time = 'pm';
    hours = parseInt(hours) - 12;
  }

  if (hours === 0) {
    hours = "12"
  } else if (hours < 10) {
    hours = '0' + hours;
  }
  let minutes = Math.floor((seconds % 3600) / 60);
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  
  return `${hours}:${minutes}${time}`;
};

function getTimezoneName(date) {
  const short = date.toLocaleDateString(undefined);
  const full = date.toLocaleDateString(undefined, { timeZoneName: 'long' });
  const shortIndex = full.indexOf(short);
  if (shortIndex >= 0) {
    const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);
    return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, '');
  } else {
    return full.substr(11);;
  }
}

export const getReadableBookedTime = (startTimestamp = 0, endTimestamp = 0, short = false, dateOnly = false,) => {
  let startDate = new Date(startTimestamp * 1000);
  let endDate = new Date(endTimestamp * 1000);

  let startTime = timestampToReadableTime(startDate)
  let endTime = timestampToReadableTime(endDate)

  let shortTimeZone = getTimezoneName(startDate).split(' ').map(word => word[0]).join('');
  return `${weeks[startDate.getDay()] || '--'} ${startDate.getDate() || '--'} ${months[startDate.getMonth()] || '--'}${!dateOnly ? `, ${startTime}${!short ? ` to ${endTime} ${shortTimeZone}` : ''}` : ''}`
}

export const timestampToReadableTime = (date) => {

  let hours = date.getHours();
  let time = 'am';
  if (parseInt(hours) > 11) {
    time = 'pm';
    hours = parseInt(hours) - 12;
  }

  if (hours === 0) {
    hours = "12"
  } else if (hours < 10) {
    hours = '0' + hours;
  }
  let minutes = date.getMinutes();
  if (minutes < 10) {
    minutes = '0' + minutes;
  };
  return `${hours}:${minutes}${time}`
}


export const convertSecondsToMin = (seconds) => {
  return Math.floor(seconds / 60);
};

export const sideScroll = (element, direction, speed, distance, step) => {
  let scrollAmount = 0;
  var slideTimer = setInterval(function () {
    if (direction == 'left') {
      element.scrollLeft -= step;
    } else {
      element.scrollLeft += step;
    }
    scrollAmount += step;
    if (scrollAmount >= distance) {
      window.clearInterval(slideTimer);
    }
  }, speed);
}